import React, { ChangeEvent, useEffect, useMemo, useRef, useState } from 'react';
import './AddressFieldComponent.scss';
import { Address, FormField } from '../types';
import { default as ReactSelect, components } from 'react-select';
import countryList from 'react-select-country-list';
import { DropDown } from '@/components/dropdown/DropDown';

type DynamicFormFieldProps = {
  data: Address;
  disabled: boolean;
  onFormFieldChange?: (data: Address) => void;
};

const AddressFieldComponent = ({ data, disabled, onFormFieldChange }: DynamicFormFieldProps) => {
  const [addressData, setAddressData] = useState<Address>();
  const countries = useMemo(() => countryList().getData(), []);

  useEffect(() => {
    if (data) {
      setAddressData(data);
    } else {
      setAddressData({
        address: '',
        country: '',
        zipCode: '',
      });
    }
  }, [data]);
  const onInputChange = (e: any) => {
    if (addressData) {
      addressData[e.target.id as keyof typeof addressData] = e.target.value;
      //setAddressData({ ...addressData });
      onFormFieldChange && onFormFieldChange({ ...addressData });
    }
  };
  const BasicOption = (props: any) => {
    return (
      <div>
        <components.Option {...props}>
          <div className="option-label">{props.label}</div>
        </components.Option>
      </div>
    );
  };
  return (
    <div className="address-field">
      <div className="pet-row">
        <input
          disabled={disabled}
          value={addressData?.address}
          id="address"
          onChange={onInputChange}
          placeholder="Enter address"
          type="text"
          className={addressData?.address ? '' : 'empty'}
        />
      </div>
      <div className="pet-row">
        <div className="pet-col-6">
          <DropDown
            placeholder="Select country"
            selectedValue={addressData?.country}
            data={countries ? countries : []}
            onSelect={(value: any) => {
              if (addressData) {
                addressData.country = value.value;
                setAddressData({ ...addressData });
              }
            }}
            onDismiss={() => {}}
            enableSearch={true}
            isDisabled={disabled}
            setObject={true}
            customClass={addressData?.country ? '' : 'empty'}
          />
          {/* <ReactSelect
            isDisabled={disabled}
            classNamePrefix={'petsked-multiselect'}
            className="multiselect-react"
            isMulti={false}
            options={countries}
            components={{
              Option: BasicOption,
            }}
            onChange={(selected: any) => {
             if (addressData) {
                addressData.country = selected.label;
                setAddressData({ ...addressData });
              }}}
            value={
              addressData?.country
                ? countries?.find((country: any) => country.label == addressData?.country)
                : null
            }
            placeholder="Select country"
          /> */}
        </div>
        <div className="pet-col-6">
          <input
            disabled={disabled}
            value={addressData?.zipCode}
            placeholder="Enter zipcode"
            id="zipCode"
            onChange={onInputChange}
            type="text"
            className={addressData?.zipCode ? '' : 'empty'}
          />
        </div>
      </div>
    </div>
  );
};

export default AddressFieldComponent;
